import { useEffect } from 'react';
import { useTenant } from '../contexts/TenantContext';

export const useDocumentTitle = () => {
  const { tenantConfig } = useTenant();

  useEffect(() => {
    if (tenantConfig?.tenant_id) {
      const tenantNames = {
        'severance': 'Severance Town Center Ideas',
        'evanston': 'Evanston PAW Ideas'
      };
      
      const title = tenantNames[tenantConfig.tenant_id as keyof typeof tenantNames] || 'Community Ideas';
      document.title = title;
    }
  }, [tenantConfig?.tenant_id]);
}; 